export default __webpack_public_path__ + "static/media/car3.f783b265.png";